import { render } from "./conferenceDetailView.vue?vue&type=template&id=ecc6ee2e"
import script from "./conferenceDetailView.vue?vue&type=script&lang=js"
export * from "./conferenceDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__